const purchase = {
  title: "HitPaw Online Pro",
  subTitle: "Wählen Sie den richtigen Plan mit einfachen und transparenten Preisen",
  monthlyUppercase: "MONATLICH",
  montly: "Monatlich",
  free: "KOSTENLOS",
  yearlyUppercase: "JÄHRLICH",
  yearly: "Jährlich",
  inService: "Im Dienst",
  buyBtn: "Jetzt kaufen",
  freeTips1: "20MB maximale Dateigröße",
  freeTips2: "6 Dateien pro Tag",
  freeTips3: "Normale Verarbeitungsgeschwindigkeit",
  freeTips4: "Normale Download-Geschwindigkeit",
  freeTips5: "Entfernen Sie BG 1 Bilder pro Tag",
  freeTips6: "Zugang zu allen kostenlosen Tools",
  vipTips1: "Unbegrenzte Dateigröße",
  vipTips2: "Unbegrenzte Anzahl von Dateien pro Tag",
  vipTips3: "10x schnellere Download-Geschwindigkeit",
  vipTips4: "10X schnellere Verarbeitungsgeschwindigkeit",
  vipTips5: "Unbegrenzt",
  vipTips6: "Unbegrenztes Entfernen von BG-Bildern pro Tag",
  vipTips7: "Zugang zu allen Tools und Premium-Funktionen",
  vipTips8: "Automatische Verlängerung und jederzeitige Kündigung.",
  vipTips9: "Keine Begrenzung der Videogröße und -menge",
  vipTips10: "Bildhintergründe ohne Einschränkungen entfernen",
  vipTips11: "10x schnellere Videoverarbeitung und Download-Geschwindigkeit",
  vipTips12: "Zugang zu allen kostenlosen Tools & Premium-Funktionen",
  acceptTitle: "Wir akzeptieren",
  modalTitle: "Upgrade auf Pro für den Zugriff auf alle Premium-Funktionen",
  total: "Gesamt",
  enterCode: "Code eingeben",
  SignUpToPurchaseBtn: "Anmelden und kaufen",
  purchaseBtn: "Zum Einkaufen gehen",
  saveTips: "Sparen Sie bis zu {{num}}%",
  discount: "Rabatt",
  purchaseTips: "Automatische Verlängerung und jederzeitige Kündigung.",
  tips: "Hinweise:",
  promoCodeInvalidTips: "Ihr Promo-Code ist ungültig",
};

export default purchase;
